export const DEFAULT_SEARCH_RESULTS_PAGE_SIZE_3D = 50;
